import type { postGlobalAssistantSuggest } from './global-ai-assistant-api';
import type { GlobalAiTranscriptMessage } from './global-ai-assistant-transcript';

export type GlobalAssistantSuggestResponse = Awaited<
  ReturnType<typeof postGlobalAssistantSuggest>
>;

export type ShouldShowReportOfferContext = {
  effectiveHadClarification: boolean;
  shouldWaitForFollowUpQuestion: boolean;
};

const findLatestUnresolvedClarification = (
  transcript: readonly GlobalAiTranscriptMessage[]
):
  | Extract<GlobalAiTranscriptMessage, { kind: 'clarification' }>
  | undefined => {
  for (let index = transcript.length - 1; index >= 0; index -= 1) {
    const message = transcript[index];
    if (
      message &&
      message.role === 'assistant' &&
      message.kind === 'clarification'
    ) {
      return message;
    }
    if (message && message.role === 'user') {
      return undefined;
    }
  }
  return undefined;
};

export const shouldShowReportOffer = (
  res: Pick<
    GlobalAssistantSuggestResponse,
    'offerReport' | 'reportOffer' | 'entityScopeNeedsClarification'
  >,
  context: ShouldShowReportOfferContext,
  transcript: readonly GlobalAiTranscriptMessage[]
): boolean => {
  if (!res.offerReport || !res.reportOffer) {
    return false;
  }
  if (context.effectiveHadClarification) {
    return false;
  }
  if (res.entityScopeNeedsClarification?.trim()) {
    return false;
  }
  if (context.shouldWaitForFollowUpQuestion) {
    return false;
  }
  if (findLatestUnresolvedClarification(transcript)) {
    return false;
  }
  return true;
};
